import { defaultSellingPlanId } from "loop-config";
import { LoopEvents, AmpCartSellingPlanInitEvent, LoopWidgetSellingPlanChange, CartInterceptOnAddProductEventSucceed } from "loop-events";
import { debounce } from 'loop-utils';
import loop from "loop";

const { loadingIcon } = loop();

const LoopWidget = (function () {
  const states = {
    loading: false,
  };

  const elements = {
    /**@type{Element|null} */
    subsaveParent: null,
    /**@type{Element|HTMLSelectElement|null} */
    subsaveSelector: null,
    /**@type{Element|null} */
    onetimeOption: null,
    /**@type{Element|null} */
    widgetContainer: null,
  };

  const initWidgetElements = () => {
    elements.widgetContainer = document.querySelector(
      "product-form-component .loop-widget-container"
    );
    elements.subsaveParent = document.querySelector(
      "product-form-component [data-loop-widget-selling-plan-group]"
    );
    elements.subsaveSelector = document.querySelector(
      "product-form-component select.loop-widget-sp-selector"
    );
    elements.onetimeOption = document.querySelector(
      "product-form-component .loop-widget-purchase-option-onetime"
    );
  };

  const attachLoadingAnim = () => {
    const loadingWrapper = document.createElement('div');
    loadingWrapper.classList.add('loop-widget-loading-anim');
    loadingWrapper.innerHTML = loadingIcon;

    if (elements.widgetContainer && !elements.widgetContainer.querySelector('.loop-widget-loading-anim')) {
      elements.widgetContainer.append(loadingWrapper);
    }
  };

  const initElements = () => {
    initWidgetElements();
    attachLoadingAnim();
  }

  /**
   * 
   * @param {string|number|null} sellingPlanId 
   */
  const dispatchSellingPlanChangeEvent = (sellingPlanId) => {
    console.log('dispatchSellingPlanChangeEvent', sellingPlanId);
    if (!window || !window.cart || !window.cart.items || !window.cart.items.length) {
      return;
    }
    // setWidgetLoadingAnim(true);
    document.dispatchEvent(new LoopWidgetSellingPlanChange(sellingPlanId));
  };

  const debouncedDispatchSellingPlanChangeEvent = debounce(dispatchSellingPlanChangeEvent, 1000);

  const initWidgetEvents = () => {
    if (elements.subsaveParent) {
      elements.subsaveParent.addEventListener("click", () => {
        if (!window.activeSellingPlanId) { // if from onetime, set default selling plan id to defaultSellingPlanId (the default selling plan)
          window.activeSellingPlanId = defaultSellingPlanId;
          // debouncedDispatchSellingPlanChangeEvent(window.activeSellingPlanId);
        }
      });
    }

    if (elements.subsaveSelector) {
      elements.subsaveSelector.addEventListener("change", (e) => {
        const { target } = e;
        if (target instanceof HTMLSelectElement) {
          const selectedSellingPlanId = Number(target.value);
          if (Number.isFinite(selectedSellingPlanId)) {
            window.activeSellingPlanId = selectedSellingPlanId;
            // debouncedDispatchSellingPlanChangeEvent(window.activeSellingPlanId);
          }
        }
      });
    }

    if (elements.onetimeOption) {
      elements.onetimeOption.addEventListener("click", () => {
        console.log("onetimeOption");
        window.activeSellingPlanId = null;
        // debouncedDispatchSellingPlanChangeEvent(window.activeSellingPlanId);
      });
    }
  };

  const waitForSubsaveSelector = async () => {
    return new Promise((resolve) => {
      /** @type {number} */
      let intervalId = 0;
      let attempt = 0;
      const maxAttempt = 10;
      intervalId = setInterval(() => {
        if (attempt >= maxAttempt) {
          clearInterval(intervalId);
          resolve(0);
        }
        initElements();
        if (elements.subsaveSelector) {
          clearInterval(intervalId);
          resolve(1);
        }
        attempt++;
      }, 1000);
    });
  }

  /**
   * 
   * @param {AmpCartSellingPlanInitEvent|Event} e 
   */
  const ampCartSellingPlanInitEventHandler = async (e) => {
    console.log('ampCartSellingPlanInitEventHandler', e);

    if (states.loading) {
      return;
    }

    states.loading = true;
    setWidgetLoadingAnim(true);

    try {
      const subSaveWaiterRes = await waitForSubsaveSelector();
      initElements();

      if (! subSaveWaiterRes || ! elements.subsaveSelector) {
        console.log('ampCartSellingPlanInitEventHandler response timeout')
        return;
      }

      if (! (e instanceof AmpCartSellingPlanInitEvent)) {
        console.error('event not AmpCartSellingPlanInitEvent instance');
        return;
      }

      const { detail } = e;

      if (elements.subsaveSelector instanceof HTMLSelectElement) {
        const sellingPlanId = detail.sellingPlanId;

        if (sellingPlanId === '' || sellingPlanId === 'null' || sellingPlanId === null) {
          elements.subsaveSelector.value = defaultSellingPlanId.toString();

          if (elements.onetimeOption && elements.onetimeOption instanceof HTMLDivElement) {
            elements.onetimeOption.click();
          }

          window.__bundleBuilderDefaultSellingPlan = '';
        } else {          
          if (elements.subsaveParent && elements.subsaveParent instanceof HTMLDivElement) {
            elements.subsaveParent.click();
          }
          
          elements.subsaveSelector.value = String(sellingPlanId);
          window.__bundleBuilderDefaultSellingPlan = sellingPlanId;
        }
        
        console.log('loop widget should be updated', elements.subsaveSelector, sellingPlanId, typeof sellingPlanId)
      }
    } finally {
      states.loading = false;
      setWidgetLoadingAnim(false);
    }
  };

  const setWidgetLoadingAnim = (isLoading = false) => {
    console.log('elements.widgetContainer', elements.widgetContainer)
    if (! elements.widgetContainer) {
      return;
    }

    if (isLoading) {
      elements.widgetContainer.classList.add('loading');
    } else {
      elements.widgetContainer.classList.remove('loading');
    }
  };

  /**
   * 
   * @param {CartInterceptOnAddProductEventSucceed} e 
   */
  const cartInterceptOnAddEventSucceedHandler = (e) => {
    console.log('cartInterceptOnAddEventSucceedHandler', e);
    const { sellingPlanId } = e.detail;

    const selectParent = elements.subsaveParent;
    const select = elements.subsaveSelector;

    const oneTime = elements.onetimeOption;

    console.log(selectParent, select, oneTime, sellingPlanId);

    if (sellingPlanId && (selectParent instanceof HTMLDivElement)) {
      selectParent.click();
    } else if (!sellingPlanId && (oneTime instanceof HTMLDivElement)) {
      oneTime.click();
    }

    if (select instanceof HTMLSelectElement) {
      select.value = sellingPlanId ? sellingPlanId : String(defaultSellingPlanId);
    }
  };

  const startLoadingAnimation = () => {
    setWidgetLoadingAnim(true);
  };

  const initCartSellingPlanEventListener = () => {
    console.log("initCartSellingPlanEventListener")
    document.addEventListener(LoopEvents.ampCartStartSellingPlanInitEvent, startLoadingAnimation);
    document.addEventListener(LoopEvents.ampCartSellingPlanInitEvent, ampCartSellingPlanInitEventHandler);
    document.addEventListener(
      /** @type {string} */ (LoopEvents.cartInterceptOnAddEventSucceed),
      /** @type {EventListener} */ ((event) => {
        void cartInterceptOnAddEventSucceedHandler(/** @type {CartInterceptOnAddProductEventSucceed} */ (event));
      })
    );
  };

  const initWidgetListeners = () => {
    initElements();
    initWidgetEvents();
  };

  return { initWidgetListeners, initCartSellingPlanEventListener };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', LoopWidget.initCartSellingPlanEventListener);
} else {
  LoopWidget.initCartSellingPlanEventListener();
}

window.addEventListener('load', LoopWidget.initWidgetListeners);